import { render, staticRenderFns } from "./tmk-demographics.vue?vue&type=template&id=63fde9c2&scoped=true&"
import script from "./tmk-demographics.vue?vue&type=script&lang=js&"
export * from "./tmk-demographics.vue?vue&type=script&lang=js&"
import style0 from "./tmk-demographics.vue?vue&type=style&index=0&id=63fde9c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fde9c2",
  null
  
)

export default component.exports